(function () {
    'use strict';

    angular.module('app.surveys', [
        'app.core',
        'app.widgets'
    ]);
})();
